import { CourseCategoryList } from "./CourseCategoryList";
import clsx from "clsx";
import DomainList from "./DomainList";
import style from "./DegreeProgramListDetails.module.scss";

export const ProgramFilterContainer = ({
  setCourseType,
  setSubcourseType,
  courseType,
  subCourseType,
  isCertificationFilterSelected,
  isAffiliatePage = false,
  landingPageValue = "",
  isLandingPage = false,
}) => {
  return (
    <>
      <div className={clsx(style.filterWrapper, "flex justify-between my-3")}>
        <CourseCategoryList
          setCourseType={setCourseType}
          courseType={courseType}
          isAffiliatePage={isAffiliatePage}
          landingPageValue={landingPageValue}
          isLandingPage={isLandingPage}
        />
      </div>
      <div className={style.domain_container}>
        <DomainList
          setSubcourseType={setSubcourseType}
          subCourseType={subCourseType}
          isCertificationFilterSelected={isCertificationFilterSelected}
        />
      </div>
    </>
  );
};
